import filterTypeEnum from "../../../../components/Filter/enumerations/filterTypeEnum";
import { filterKeyReceivedData } from "./filterKeyEnum";
import {
  receivedStatusEnum,
  withdrawStatusEnum
} from "./transactionStatusEnum";

const filterSetupReceivedData = {
  //FILTER TYPE:
  // 1: with quick search
  // 2: only dropdowns
  filter_type: 2,
  filters: [
    {
      title: "normal.time",
      data_index: filterKeyReceivedData.PERIOD_WEEK,
      /**
       * Currently have 3 types
       * SELECT: dropdown
       * DATE_TIME_RANGE: select start date and end date
       * INPUT: typing the value
       */
      type: filterTypeEnum.SELECT,
      // how many options per row
      columns: 2,
      // if the data is required to fill or not
      required: true,
      //DATA TYPE: "static" and "api"
      //static is for fixed value, api is for data loaded from API
      //api: since data is from api, here don't need to add "value_enum"
      data_type: "api",
    },
    {
      title: "normal.status",
      data_index: filterKeyReceivedData.STATUS,
      type: filterTypeEnum.SELECT,
      columns: 4,
      required: false,
      //DATA TYPE: "static" and "api"
      //static is for fixed value, api is for data loaded from API
      //static: add static value_enum inside the setup file
      data_type: "static",
      value_enum: receivedStatusEnum,
    },
  ],
};

const filterSetupWithdrawData = {
  filter_type: 2,
  filters: [
    {
      title: "normal.time",
      data_index: filterKeyReceivedData.PERIOD_WEEK,
      /**
       * Currently have 3 types
       * SELECT: dropdown
       * DATE_TIME_RANGE: select start date and end date
       * INPUT: typing the value
       */
      type: filterTypeEnum.SELECT,
      // how many options per row
      columns: 2,
      // if the data is required to fill or not
      required: true,
      //DATA TYPE: "static" and "api"
      //static is for fixed value, api is for data loaded from API
      //api: since data is from api, here don't need to add "value_enum"
      data_type: "api",
    },
    {
      title: "normal.status",
      data_index: filterKeyReceivedData.STATUS,
      type: filterTypeEnum.SELECT,
      columns: 4,
      required: false,
      //DATA TYPE: "static" and "api"
      //static is for fixed value, api is for data loaded from API
      //static: add static value_enum inside the setup file
      data_type: "static",
      value_enum: withdrawStatusEnum,
    },
  ],
};

export { filterSetupReceivedData, filterSetupWithdrawData };
